// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { createClientLogger } from "@azure/logger";

/**
 * The `@azure/logger` configuration for this package.
 * @internal
 */
export const logger = createClientLogger("ai-text-analytics");
